<template>
    <div class="paginator-wrapper">
        <div class="paginator">
            <span
                class="page-wrapper"
                v-for="(page, index) in filteredPages"
                :key="`page-${page}`"
            >
                <span
                    class="page"
                    :class="{['active']: page === currentPage }"
                    @click="onGoToPageCallback(page)"
                >
                    {{page}}
                </span>
                <span class="gap" v-if="showGap(page, index)">...</span>
            </span>
        </div>
        <div class="direct-navigation" v-if="pages.length > 7">
            <input
                class="form-control"
                v-model="targetPage"
                placeholder="Page"
                name="targetPage"
                autocomplete="off"
                @keyup.enter="onDirectPageNavigation"
            />
            <button
                class="btn btn-primary submit-btn"
                @click="onDirectPageNavigation"
            >
                Go
            </button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Paginator',
    props: [
        'currentPage',
        'onGoToPageCallback',
        'pages',
    ],
    created() {
        this.filteredPages = this.getPages();
    },
    data() {
        return {
            filteredPages: [],
            targetPage: null,
        };
    },
    methods: {
        onDirectPageNavigation() {
            const targetPage = parseInt(this.targetPage, 10);

            if (this.pages.includes(targetPage)) {
                this.onGoToPageCallback(targetPage);
            } else {
                this.$notify({
                    group: 'app',
                    title: 'Error',
                    type: 'error',
                    text: 'Invalid page',
                });
            }
        },
        getPages() {
            const pages = this.pages;
            const currentPage = this.currentPage;
            const filteredPages = [];
            const prevPages = [];
            const nextPages = [];

            const currentPageIndex = pages.findIndex(page => page === currentPage);

            if (currentPageIndex !== -1) {

                filteredPages.push(currentPage);

                for (let i = currentPageIndex + 1; i < pages.length; i++) {

                    if (pages[i]) {
                        nextPages.push(pages[i]);
                    }

                    if (nextPages.length >= 4) {
                        break;
                    }
                }

                for (let i = currentPageIndex - 1; i >= 0; i--) {
                    if (pages[i]) {
                        prevPages.push(pages[i]);
                    }

                    if (prevPages.length >= 4) {
                        break;
                    }
                }
            }

            for (let i = 0; i < 5; i++) {
                if (prevPages[i]) {
                    filteredPages.push(prevPages[i]);
                }

                if (nextPages[i]) {
                    filteredPages.push(nextPages[i]);
                }

                if (filteredPages.length >= 5) {
                    break;
                }
            }

            if (pages.length) {
                if (!filteredPages.includes(1)) {
                    filteredPages.push(1);
                }

                if (!filteredPages.includes(pages[pages.length - 1])) {
                    filteredPages.push(pages[pages.length - 1]);
                }
            }

            return filteredPages.sort((a, b) => a - b);
        },
        showGap(page, index) {
            const lastPage = this.pages[this.pages.length - 1];
            const isSecondToLast = index === this.filteredPages.length - 2;

            return (index === 0 && this.filteredPages[1] - 1 > 1) ||
                (this.pages.length > 5 && isSecondToLast && lastPage - page > 1);
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .paginator {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .page-wrapper {
            margin: 0 2.5px;

            .page {
                background: white;
                border: 1px solid $light-gray;
                padding: 2px 10px;
                display: inline-block;
                cursor: pointer;
                margin-bottom: 10px;

                &.active {
                    border-color: $dark-gray;
                }
            }
        }
    }

    .direct-navigation {
        display: flex;
        justify-content: center;
        font-size: .9em;

        .form-control {
            max-width: 75px;
            min-height: 36px;
            padding: 6px 10px;
        }

        .submit-btn {
            margin-left: 10px;
            padding: 6px 15px;
        }
    }

    @media only screen and (min-width: $screen-sm) {
        .paginator {
            margin: 0 20%;
        }
    }

    @media only screen and (min-width: $screen-md) {
        .paginator {
            margin: 0 10%;
        }
    }
</style>
